/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/shipyard_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 19.664L31.414 16l-3.664-3.664V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086zm-.5-14.914v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zM3.414 16L16 3.414 28.586 16 16 28.586 3.414 16zm16.75 11.25l7.086-7.086v7.086h-7.086z"/><path pid="1" d="M17.867 13.333L16 17.066l-1.867-3.733z"/><path pid="2" d="M12.801 13.333L16 19.732l3.199-6.399h2.134L15.992 24l-5.325-10.667zM14 12h4v.667h-4zM15.333 10h1.333v1.333h-1.333z"/>'
  }
})
